import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import { authSet } from '../../utils/request';
import { METHOD_POST } from '../../constants/api';

const postFedexPickup = createAsyncThunk('fedex/postPickup',
  async (formData = {}, { rejectWithValue }) => {
    try {
      return await authSet(METHOD_POST, '/fedex/pickup', formData);
    } catch (err) {
      return rejectWithValue(err?.errors?.[0].message || 'Failed to create pickup');
    }
  });

export const clearPostFedexPickup = createAction('clearPostFedexPickup');

export default postFedexPickup;
